import { AnyStateWithRefund } from '../types';

export const getModalState = (state: AnyStateWithRefund) => state.refund.modal;
